import { Http } from '@angular/http';
/*--------------
V 0.0.1 - Criado por Larner Diogo

DESCRICAO:
Serviço de autenticação de usuário


COMPONENTS
***********************************************************/
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

/**********************************************************
PROVIDERS
***********************************************************/
import { StorageService } from './storage';


@Injectable()
export class SessionService {

  private _isLogged: boolean = false;
  private _userTeste: string = 'root@root.com.br';
  private _senhaTeste: string = '123';
  private _nomeTeste: string = 'Usuário Padrão';
  public nomeUserLogado: string;

  constructor(
    private _Router: Router,
    private _StorageService: StorageService
  ) {

    //verificando se user esta logado no storage
    if (this._StorageService.getItem('isLogged') == 'true') {
      this.setIsLogged(true);
      this.nomeUserLogado = this._StorageService.getItem('nameUser');
    }

  }

  //RETORNA SE USUARIO ESTÁ LOGADO
  getIsLogged() {
    return this._isLogged;
  }

  //RETORNA SE USUARIO ESTÁ LOGADO
  setIsLogged(value) {
    return this._isLogged = value;
  }

  //RETORNA SE USUARIO ESTÁ LOGADO
  getUserTeste() {

    let dataUser = [];
    dataUser.push(this._userTeste);
    dataUser.push(this._senhaTeste);
    dataUser.push(this._nomeTeste);

    return dataUser;
  }

}


// WEBPACK FOOTER //
// ./src/app/globals/session.ts